//angular.module('webcomm', ['ngRoute', 'LocalStorageModule', 'luegg.directives', 'uiGmapgoogle-maps', 'nemLogging'])
angular.module('webcomm', ['ngRoute', 'LocalStorageModule', 'luegg.directives', 'rzModule', 'ngMap', 'ngAnimate', 'ui.bootstrap', 'ngIdle', 'webcomm.constants'])
    .constant('Modernizr', Modernizr)
    .run(['wtcpjsClientProviderService', function(svc) {
        svc.createClient();
    }])
    .run([
        '$rootScope',
        '$log',
        'muteService',
        'connectionService',
        'endpointStatusService',
        'notificationService',
        'audioService', function (
            $rootScope,
            $log,
            muteService,
            connectionService,
            endpointStatusService,
            notificationService,
            audioService) { // a lot of these are included here so they startup with app

        $log.debug('application initialized');
        //$log.info('$location.path:', $location.path());

        // change the body ID for the page
        $rootScope.$on('$locationChangeSuccess', function(event, newUrl) {
            var mainPageRegex = /#\/main/;
            if (newUrl.match(mainPageRegex)) {
                $rootScope.id = 'main-page';
            } else {
                $rootScope.id = 'login-page';
                // this is resets the global in app.global.js when the app restarts - prevents history popup.
                window.initialLoad = true;
            }
        });
    }]);
